export default "__VITE_ASSET__D1duZKjk__"